// MapFocusPill — the focus-mode banner on the map pages (spec:
// docs/specs/scout-spray-map-record-focus.md). Sits between the page
// header and the map; the message (active / offline / error-fallback /
// loading) is the caller's JSX, the container + "Show all" escape hatch
// are shared so the two maps can't drift on tap size, wording, or the
// clear affordance. Tone matches the page's record colour (cyan = spray
// tracks, lime = scouting).
import { type ReactNode } from 'react'

const TONES = {
  cyan: {
    wrap: 'border-cyan-800/40 bg-cyan-950/30',
    text: 'text-cyan-200',
    btn:  'text-cyan-300 hover:text-cyan-100',
  },
  lime: {
    wrap: 'border-lime-800/40 bg-lime-950/30',
    text: 'text-lime-200',
    btn:  'text-lime-300 hover:text-lime-100',
  },
  // amber = BigHarvest pins (the harvest board's record colour).
  amber: {
    wrap: 'border-amber-800/40 bg-amber-950/30',
    text: 'text-amber-200',
    btn:  'text-amber-300 hover:text-amber-100',
  },
} as const

export function MapFocusPill({ tone, onShowAll, children }: {
  tone: keyof typeof TONES
  onShowAll: () => void
  children: ReactNode
}) {
  const t = TONES[tone]
  return (
    <div className={`px-4 py-2 border-b ${t.wrap} flex items-center gap-2 shrink-0`}>
      <p className={`text-[11px] ${t.text} flex-1`}>{children}</p>
      <button onClick={onShowAll}
        className={`text-[11px] ${t.btn} underline underline-offset-2 min-h-[44px] px-2 -my-2 inline-flex items-center shrink-0`}>
        Show all
      </button>
    </div>
  )
}
